import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./store/store";
import { startRootSaga } from "./store/sagas/rootSaga";

import "./index.css";

import App from "./App";

startRootSaga();

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById("root")
);
